import getCart from './getCart';

const getCartMinDeliveryAmount = state =>
  getCart(state)?.minDeliveryAmount || 0;

export default getCartMinDeliveryAmount;
